import { Type } from '@angular/core';
import { BookingConfirmedBaseStep } from '@luggagehero/features/bookings';

import { GoToShopActionComponent, SelectPaymentMethodActionComponent } from '../booking-actions';

export class BookingConfirmedStep extends BookingConfirmedBaseStep {
  get goToShopActionComponentType(): Type<GoToShopActionComponent> {
    return GoToShopActionComponent;
  }

  get selectPaymentMethodActionComponentType(): Type<SelectPaymentMethodActionComponent> {
    return SelectPaymentMethodActionComponent;
  }
}
